import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '@gettactic/hooks';

export const useUserOfficesAvailability = ({
  officeIds,
  dates
}: {
  officeIds: string[];
  dates: string[];
}) => {
  const { apiClient } = useTacticHooks();
  // Only enable the query if we have both officeIds and dates
  const hasData = officeIds.length > 0 && dates.length > 0;
  
  return useQuery({
    queryKey: ['userOfficesAvailability', hasData ? [...officeIds].sort() : [], hasData ? [...dates].sort() : []],
    queryFn: async () => {
      if (!hasData) {
        return null;
      }
      
      const response = await apiClient.organizations.getOfficesAvailability(officeIds, dates);
      if (response.ok) {
        return response.result;
      }
      return null;
    },
    enabled: hasData,
    keepPreviousData: true
  });
};
